import React from 'react'

const PopUp = () => {
  return (
    <>

      {/* PopUp */}


      <div className="container" style={{ overflow: "" }}>
        <div className="row">
          <div className="col-md-12">
            <div className="modal" id="mypopUpForm">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button style={{ color: "#0f903f" }} className="close" data-dismiss="modal">
                      <b style={{ color: "#000000", fontSize: "24px" }}>X</b>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="col-lg-12" data-aos="fade-left" data-aos-delay={100}>
                      <br />
                      <br />
                      <img className='' src="https://res.cloudinary.com/dedml8dsw/image/upload/v1769053749/Admissions_open_1_sggnoo.webp" alt style={{ marginTop: "-50px", borderRadius: "10px", maxWidth:"100%", paddingRight:"100px" }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default PopUp